import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "diary-edit" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", null, "Verstreken werkdagen", -1)
const _hoisted_3 = { style: {"font-size":"14px"} }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", null, "Onwerkbare werkdagen", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h4", null, "Resterende werkdagen", -1)
const _hoisted_6 = { style: {"font-size":"14px"} }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { style: {"font-size":"12px","font-weight":"400"} }
const _hoisted_9 = { style: {"font-weight":"500"} }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Is de dagstart gehouden door de uitvoerder?"),
  /*#__PURE__*/_createElementVNode("li", null, "Zijn alle nieuwe medewerkers op de bouwplaats ingeschreven met de projectinformatie?"),
  /*#__PURE__*/_createElementVNode("li", null, "Is er werkbezoek interne veiligheids kundige Henk Tijssen?"),
  /*#__PURE__*/_createElementVNode("li", null, "Is er een Toolbox gehouden met ZZPèrs / CAOèrs die we rechtsreeks inhuren?"),
  /*#__PURE__*/_createElementVNode("li", null, "Zijn er vandaag nieuwe werkzaamheden gestart waar we een TRA moeten maken – bijzondere gevallen die niet in het V&G plan zijn omschreven maar wel een verhoogd risico aan vast zit?")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, "Incidenten", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Zijn er vandaag specifieke keuringen op de planning volgens WKB en/of energielabel?"),
  /*#__PURE__*/_createElementVNode("li", null, "Bezoek Niemann?"),
  /*#__PURE__*/_createElementVNode("li", null, "Bezoek Bouw-inspecteur gemeente?"),
  /*#__PURE__*/_createElementVNode("li", null, "Bezoek WKB-inspecteur?"),
  /*#__PURE__*/_createElementVNode("li", null, "Overige keuringen?")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", null, "Voltooide keuringen", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Is de standlijn op overal planning gemaakt?"),
  /*#__PURE__*/_createElementVNode("li", null, "2-wekelijke planning duidelijk bij alle onderaannemers – leveranciers?")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", null, "Voltooide voorschouwen", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", null, "Voltooide opleveringen", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = { key: 1 }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Interne vergadering met projectteam gehouden?"),
  /*#__PURE__*/_createElementVNode("li", null, "Verslaglegging van dit interne overleg?"),
  /*#__PURE__*/_createElementVNode("li", null, "2-wekelijks projectleiders overleg met de betrokken partijen?"),
  /*#__PURE__*/_createElementVNode("li", null, "Verslaglegging van dit overleg ook gedeeld?")
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", null, "Startgesprekken", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = { key: 1 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Meer-minderwerk elke week afronden door Thunnissen en desbetreffende onderaannemer/ leverancier")
], -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Zijn er leveringen gedaan? Koppel hier de leveringsbonnen."),
  /*#__PURE__*/_createElementVNode("li", null, "Overige documenten.")
], -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("b", null, "Weet je zeker dat je deze registratie wilt verwijderen?", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", null, "Bedrijf", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", { style: {"font-weight":"bold"} }, "Let op!", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", null, "Alle ingevulde aanwezigheid van de huidige periode zal worden overschreven.", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", null, "Kopiëren van", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Omschrijving meer- minderwerk "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Bedrag "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", null, "Totaal meer- minderwerk voorgaande weken", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("b", null, "Weet je zeker dat je deze signalering wilt verwijderen?", -1)

import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { diaryStore } from '@/stores/diary'
import PageTitleBar from '@/components/PageTitleBar.vue'
import Column from '@/types/column'
import { DiaryDay, DiaryRegistration } from '@/types/diary'
import axios from 'axios'
import { message, notification } from 'ant-design-vue'
import { EyeOutlined, PlusOutlined, CopyOutlined, DeleteOutlined, CheckOutlined, FileOutlined } from '@ant-design/icons-vue'
import Uploader from '@/components/Uploader.vue'
import Filelist from '@/components/Filelist.vue'
import { authStore } from '@/stores/auth'
import { can, canAny } from '@/globalFunctions'


export default /*#__PURE__*/_defineComponent({
  __name: 'DiaryEdit',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const diaryColumns = ref<Column[]>([
  {
    title: 'Dag',
    key: 'day',
    width: 120
  },
  {
    title: 'Werkbaar',
    key: 'workable',
    width: 320
  },
  {
    title: 'Omschrijving van de dag',
    key: 'description'
  }
])

const incidentColumns = ref<Column[]>([
  {
    title: '#',
    key: 'id'
  },
  {
    title: 'Formulier',
    key: 'form'
  },
  {
    title: 'Aangemaakt door',
    key: 'created_by_user'
  },
  {
    title: 'Actie\'s',
    key: 'actions'
  }
])

const surveyColumns = ref<Column[]>([
  {
    title: '#',
    key: 'id'
  },
  {
    title: 'Type',
    key: 'type'
  },
  {
    title: 'Formulier',
    key: 'survey_form'
  },
  {
    title: 'Blok',
    key: 'block'
  },
  {
    title: 'Bouwnummer',
    key: 'building'
  },
  {
    title: 'Uitgevoerd door',
    key: 'completed_by_user'
  },
  {
    title: 'Actie\'s',
    key: 'actions'
  }
])

const deliveryColumns = ref<Column[]>([
  {
    title: '#',
    key: 'id'
  },
  {
    title: 'Bouwnummer',
    key: 'building'
  },
  {
    title: 'Uitgevoerd door',
    key: 'completed_by_user'
  },
  {
    title: 'Actie\'s',
    key: 'actions'
  }
])

const kickoffMeetingsWithSubcontractorColumns = ref<Column[]>([
  {
    title: '#',
    key: 'id'
  },
  {
    title: 'Formulier',
    key: 'form'
  },
  {
    title: 'Bedrijf',
    key: 'company'
  },
  {
    title: 'Aangemaakt door',
    key: 'created_by_user'
  },
  {
    title: 'Actie\'s',
    key: 'actions'
  }
])

const registrationColumns = ref<Column[]>([
  {
    title: 'Bedrijf',
    key: 'company',
    width: 200
  },
  {
    title: 'Maandag',
    key: 'monday'
  },
  {
    title: 'Dinsdag',
    key: 'tuesday'
  },
  {
    title: 'Woensdag',
    key: 'wednesday'
  },
  {
    title: 'Donderdag',
    key: 'thursday'
  },
  {
    title: 'Vrijdag',
    key: 'friday'
  },
  {
    title: 'Zaterdag',
    key: 'saturday'
  },
  {
    title: 'Zondag',
    key: 'sunday'
  },
  {
    title: 'Actie\'s',
    key: 'actions'
  }
])

const registrationsCounter = computed(() => {
  const counter = { monday: 0, tuesday: 0, wednesday: 0, thursday: 0, friday: 0, saturday: 0, sunday: 0 }

  if (!diaryStore().diary) return counter

  diaryStore().diary.registrations.forEach((r:DiaryRegistration) => {
    counter.monday += r.monday
    counter.tuesday += r.tuesday
    counter.wednesday += r.wednesday
    counter.thursday += r.thursday
    counter.friday += r.friday
    counter.saturday += r.saturday
    counter.sunday += r.sunday
  })

  return counter
})

const diaryClosed = computed(() => {
  return diaryStore().diary?.status === 0
})

const showNewRegistrationModal = ref(false)
const newRegistration = ref({ diary_id: route.params.diaryId, company_id: null, monday: 0, tuesday: 0, wednesday: 0, thursday: 0, friday: 0, saturday: 0, sunday: 0 })
const companies = ref([])

const showCopyRegistrationsModal = ref(false)
const diaryIdToCopyFrom = ref<number|null>(null)
const previousWeeks = ref([])

const showSignalingModal = ref(false)
const diaryRegistration = ref<DiaryRegistration|null>(null)

const canViewKam = computed(() => canAny([
  'construction_site_portal.kam_forms.view',
  'construction_site_portal.kam_forms.edit'
]))

const canViewSurveys = computed(() => canAny([
  'construction_site_portal.surveys.view',
  'construction_site_portal.surveys.edit',
  'construction_site_portal.external_inspections.view',
  'construction_site_portal.external_inspections.edit'
]))

const canViewDeliveries = computed(() => can('construction_site_portal.deliveries.edit'))

onMounted(() => {
  diaryStore().getDiary(route.params.diaryId.toString())
})

onBeforeUnmount(() => {
  diaryStore().diary = null
  diaryStore().errors = {}
})

function toggleNewRegistrationModal () : void {
  showNewRegistrationModal.value = !showNewRegistrationModal.value

  if (showNewRegistrationModal.value) {
    getCompanies()
  } else {
    newRegistration.value.company_id = null
    companies.value = []
  }
}

function getCompanies () : void {
  if (diaryStore().diary.project_id) {
    axios.get(process.env.VUE_APP_API_URL + '/diaries/' + diaryStore().diary.id + '/companies/projects/' + diaryStore().diary.project_id).then((r) => {
      companies.value = r.data
    })
  }
}

function addCompany () : void {
  diaryStore().loading.saving = true
  axios.post(process.env.VUE_APP_API_URL + '/diaries/' + diaryStore().diary.id + '/registrations', newRegistration.value).then(() => {
    toggleNewRegistrationModal()
    diaryStore().getDiary(route.params.diaryId.toString())
    message.success('Bedrijf toegevoegd.')
  }).catch(() => {
    message.error('Er is iets mis gegaan. Probeer het later nog eens.', 10)
  }).finally(() => {
    diaryStore().loading.saving = false
  })
}

function toggleCopyRegistrationsModal () : void {
  showCopyRegistrationsModal.value = !showCopyRegistrationsModal.value

  if (showCopyRegistrationsModal.value) {
    getPreviousWeeks()
  } else {
    diaryIdToCopyFrom.value = null
    previousWeeks.value = []
  }
}

function getPreviousWeeks () : void {
  axios.get(process.env.VUE_APP_API_URL + '/diaries/' + diaryStore().diary.id + '/previous').then((r) => {
    previousWeeks.value = r.data
  })
}

function copyDiaryRegistrations () : void {
  diaryStore().loading.saving = true
  axios.post(process.env.VUE_APP_API_URL + '/diaries/' + diaryStore().diary.id + '/registrations/copy', { copyFromDiaryId: diaryIdToCopyFrom.value }).then(() => {
    toggleCopyRegistrationsModal()
    diaryStore().getDiary(route.params.diaryId.toString())
    message.success('Aanwezigheid gekopieerd.')
  }).catch(() => {
    message.error('Er is iets mis gegaan. Probeer het later nog eens.', 10)
  }).finally(() => {
    diaryStore().loading.saving = false
  })
}

function deleteDiaryRegistration (id:number) : void {
  diaryStore().loading.deleting = id
  axios.delete(process.env.VUE_APP_API_URL + '/diaries/registrations/' + id).then(() => {
    diaryStore().getDiary(route.params.diaryId.toString())
  }).catch(() => {
    message.error('Er is iets mis gegaan. Probeer het later nog eens.', 10)
  }).finally(() => {
    diaryStore().loading.deleting = 0
  })
}

function toggleSignalingModal (dr:DiaryRegistration|null = null) : void {
  showSignalingModal.value = !showSignalingModal.value
  diaryRegistration.value = dr
}

function storeSignaling () : void {
  if (diaryRegistration.value) {
    diaryStore().loading.saving = true
    axios.put(process.env.VUE_APP_API_URL + '/diaries/registrations/' + diaryRegistration.value.id, diaryRegistration.value).then(() => {
      message.success('Signalering meer- minderwerk bijgewerkt.')
      toggleSignalingModal()
    }).catch(() => {
      message.error('Er is iets mis gegaan. Herlaad de pagina en pas de gegevens opnieuw aan.', 0)
    }).finally(() => {
      diaryStore().loading.saving = false
    })
  }
}

function clearSignaling () : void {
  if (diaryRegistration.value) {
    diaryStore().loading.clearing = true
    diaryRegistration.value.text_signaling = null
    diaryRegistration.value.amount_signaling = null
    axios.put(process.env.VUE_APP_API_URL + '/diaries/registrations/' + diaryRegistration.value.id, diaryRegistration.value).then(() => {
      message.success('Signalering meer- minderwerk gewist.')
      toggleSignalingModal()
    }).catch(() => {
      message.error('Er is iets mis gegaan. Herlaad de pagina en pas de gegevens opnieuw aan.', 0)
    }).finally(() => {
      diaryStore().loading.clearing = false
    })
  }
}

function closeWeek () : void {
  diaryStore().loading.closing = true
  axios.post(process.env.VUE_APP_API_URL + '/diaries/' + route.params.diaryId + '/close').then(() => {
    diaryStore().getDiary(route.params.diaryId.toString())
    notification.success({
      message: 'Week gesloten.',
      description: 'De week is succesvol afgesloten. Je ontvangt zo een mail met het weekrapport.',
      duration: 5
    })
  }).catch(() => {
    notification.error({
      message: 'Week NIET gesloten.',
      description: 'Er is iets mis gegaan. Probeer het later nog eens.'
    })
  }).finally(() => {
    diaryStore().loading.closing = false
  })
}

function downloadReport () : void {
  window.open(diaryStore().diary.pdf?.url, '_blank')
}

function addFile (diaryDay:DiaryDay, file:File) : void {
  const formData = new FormData()
  formData.append('files', file)

  axios.post(process.env.VUE_APP_API_URL + '/diaries/days/' + diaryDay.id + '/media', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(() => {
    diaryStore().getDiary(route.params.diaryId.toString())
  })
}

function deleteFile (diaryDay:DiaryDay, file:{ id:number }) : void {
  axios.delete(process.env.VUE_APP_API_URL + '/diaries/days/' + diaryDay.id + '/media/' + file.id).then(() => {
    diaryStore().getDiary(route.params.diaryId.toString())
  })
}

function filterByName (input:string, item:{ name:string }) {
  return item.name.toLowerCase().indexOf(input.toLowerCase()) >= 0
}

function openInNewTab (to:{ name:string, params: { [key:string]:number }}) {
  const route = router.resolve(to)
  window.open(route.href, '_blank')
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_statistic = _resolveComponent("a-statistic")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table_summary_cell = _resolveComponent("a-table-summary-cell")!
  const _component_a_table_summary_row = _resolveComponent("a-table-summary-row")!
  const _component_a_table_summary = _resolveComponent("a-table-summary")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageTitleBar, null, {
      title: _withCtx(() => [
        _createTextVNode("Uitvoerdersdagboek")
      ]),
      subtitle: _withCtx(() => [
        (_unref(diaryStore)().diary && _unref(diaryStore)().diary.project)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_unref(diaryStore)().diary.project.name), 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode("Aan het laden..")
            ], 64))
      ]),
      buttons: _withCtx(() => [
        (_unref(diaryStore)().diary && !_unref(diaryClosed))
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              type: "primary",
              loading: _unref(diaryStore)().loading.closing,
              disabled: _unref(diaryStore)().loading.closing,
              onClick: closeWeek
            }, {
              default: _withCtx(() => [
                _createTextVNode("Week afsluiten")
              ]),
              _: 1
            }, 8, ["loading", "disabled"]))
          : _createCommentVNode("", true),
        (_unref(diaryStore)().diary && _unref(diaryStore)().diary.pdf)
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 1,
              type: _unref(diaryClosed) ? 'primary' : '',
              loading: _unref(diaryStore)().loading.generating,
              disabled: _unref(diaryStore)().loading.generating,
              onClick: downloadReport
            }, {
              default: _withCtx(() => [
                _createTextVNode("Download weekrapport")
              ]),
              _: 1
            }, 8, ["type", "loading", "disabled"]))
          : _createCommentVNode("", true),
        _createVNode(_component_a_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'Diaries' })))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Terug naar overzicht")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, { gutter: [16, 16] }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 8 }, {
          default: _withCtx(() => [
            (_unref(diaryStore)().diary)
              ? (_openBlock(), _createBlock(_component_a_card, {
                  key: 0,
                  bordered: false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_statistic, {
                      value: _unref(diaryStore)().diary.schedule.elapsed_work_days
                    }, {
                      title: _withCtx(() => [
                        _hoisted_2
                      ]),
                      suffix: _withCtx(() => [
                        _createElementVNode("span", _hoisted_3, "/ " + _toDisplayString(_unref(diaryStore)().diary.schedule.scheduled_days), 1)
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 8 }, {
          default: _withCtx(() => [
            (_unref(diaryStore)().diary)
              ? (_openBlock(), _createBlock(_component_a_card, {
                  key: 0,
                  bordered: false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_statistic, {
                      value: _unref(diaryStore)().diary.schedule.non_workable_days
                    }, {
                      title: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 8 }, {
          default: _withCtx(() => [
            (_unref(diaryStore)().diary)
              ? (_openBlock(), _createBlock(_component_a_card, {
                  key: 0,
                  bordered: false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_statistic, {
                      value: _unref(diaryStore)().diary.schedule.remaining_work_days
                    }, {
                      title: _withCtx(() => [
                        _hoisted_5
                      ]),
                      suffix: _withCtx(() => [
                        _createElementVNode("span", _hoisted_6, "/ " + _toDisplayString(_unref(diaryStore)().diary.schedule.scheduled_days), 1)
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 24 }, {
          default: _withCtx(() => [
            (_unref(diaryStore)().diary)
              ? (_openBlock(), _createBlock(_component_a_card, {
                  key: 0,
                  bordered: false
                }, {
                  title: _withCtx(() => [
                    _createTextVNode(" Week " + _toDisplayString(_unref(diaryStore)().diary.week) + ", " + _toDisplayString(_unref(diaryStore)().diary.year), 1),
                    _hoisted_7,
                    _createElementVNode("span", _hoisted_8, "Van " + _toDisplayString(new Date(_unref(diaryStore)().diary.dates.monday).toLocaleDateString('nl-NL')) + " t/m " + _toDisplayString(new Date(_unref(diaryStore)().diary.dates.sunday).toLocaleDateString('nl-NL')), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_row, {
                      gutter: [16,16],
                      class: "no-mb"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, {
                          xs: {span: 24},
                          sm: {span: 24},
                          md: {span: 24},
                          lg: {span: 24}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_table, {
                              columns: diaryColumns.value,
                              "data-source": _unref(diaryStore)().diary.days,
                              pagination: false,
                              scroll: { x: true },
                              class: "diary-table"
                            }, {
                              bodyCell: _withCtx(({ column, record }) => [
                                (column.key === 'day')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createElementVNode("span", _hoisted_9, _toDisplayString(record.day), 1),
                                      _hoisted_10,
                                      _createTextVNode(" " + _toDisplayString(new Date(record.date).toLocaleDateString('nl-NL')), 1)
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (column.key === 'workable')
                                  ? (_openBlock(), _createBlock(_component_a_radio_group, {
                                      key: 1,
                                      "button-style": "solid",
                                      style: { display: 'inline-flex' },
                                      disabled: _unref(diaryClosed),
                                      value: record.workable,
                                      "onUpdate:value": ($event: any) => ((record.workable) = $event),
                                      onChange: ($event: any) => (_unref(diaryStore)().updateDiaryDay(record))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_radio_button, { value: 1 }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Ja")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_a_radio_button, { value: 2 }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Half")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_a_radio_button, { value: 0 }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Nee")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_a_radio_button, {
                                          value: 3,
                                          style: {"width":"max-content"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Geen werkdag")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["disabled", "value", "onUpdate:value", "onChange"]))
                                  : _createCommentVNode("", true),
                                (column.key === 'description')
                                  ? (_openBlock(), _createBlock(_component_a_collapse, {
                                      key: 2,
                                      class: "diary-collapse",
                                      bordered: false,
                                      accordion: true
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_collapse_panel, { header: "Veiligheid" }, {
                                          extra: _withCtx(() => [
                                            (record.text_safety && record.text_safety.length > 3)
                                              ? (_openBlock(), _createBlock(_unref(CheckOutlined), {
                                                  key: 0,
                                                  style: { color: 'green' }
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_row, { gutter: [16,16] }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_col, { span: 24 }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_11,
                                                    _createVNode(_component_a_textarea, {
                                                      style: {"min-width":"260px"},
                                                      autoSize: { minRows: 3, maxRows: 6 },
                                                      disabled: _unref(diaryClosed),
                                                      value: record.text_safety,
                                                      "onUpdate:value": ($event: any) => ((record.text_safety) = $event),
                                                      onBlur: ($event: any) => (_unref(diaryStore)().updateDiaryDay(record))
                                                    }, null, 8, ["disabled", "value", "onUpdate:value", "onBlur"])
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_a_col, { span: 24 }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_12,
                                                    _hoisted_13,
                                                    (record.incidents.length)
                                                      ? (_openBlock(), _createBlock(_component_a_table, {
                                                          key: 0,
                                                          columns: incidentColumns.value,
                                                          "data-source": record.incidents,
                                                          pagination: false
                                                        }, {
                                                          bodyCell: _withCtx(({ column, record }) => [
                                                            (column.key === 'id')
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                  _createTextVNode(_toDisplayString(record.id), 1)
                                                                ], 64))
                                                              : _createCommentVNode("", true),
                                                            (column.key === 'form')
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                  _createTextVNode(_toDisplayString(record.name), 1)
                                                                ], 64))
                                                              : _createCommentVNode("", true),
                                                            (column.key === 'created_by_user')
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                                  _createTextVNode(_toDisplayString(record.created_by_user ? record.created_by_user.full_name : '-'), 1)
                                                                ], 64))
                                                              : _createCommentVNode("", true),
                                                            (column.key === 'actions')
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                                  (_unref(canViewKam))
                                                                    ? (_openBlock(), _createBlock(_component_a_button, {
                                                                        key: 0,
                                                                        size: "small",
                                                                        onClick: ($event: any) => (openInNewTab({ name: 'KAMFormEdit',  params: { formReference: record.reference, projectReference: record.project.reference, kamFormId: record.id } }))
                                                                      }, {
                                                                        default: _withCtx(() => [
                                                                          _createVNode(_unref(EyeOutlined))
                                                                        ]),
                                                                        _: 2
                                                                      }, 1032, ["onClick"]))
                                                                    : _createCommentVNode("", true)
                                                                ], 64))
                                                              : _createCommentVNode("", true)
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["columns", "data-source"]))
                                                      : (_openBlock(), _createElementBlock("span", _hoisted_14, "-"))
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_a_collapse_panel, { header: "Kwaliteit" }, {
                                          extra: _withCtx(() => [
                                            (record.text_quality && record.text_quality.length > 3)
                                              ? (_openBlock(), _createBlock(_unref(CheckOutlined), {
                                                  key: 0,
                                                  style: { color: 'green' }
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_row, { gutter: [16,16] }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_col, { span: 24 }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_15,
                                                    _createVNode(_component_a_textarea, {
                                                      style: {"min-width":"260px"},
                                                      autoSize: { minRows: 3, maxRows: 6 },
                                                      disabled: _unref(diaryClosed),
                                                      value: record.text_quality,
                                                      "onUpdate:value": ($event: any) => ((record.text_quality) = $event),
                                                      onBlur: ($event: any) => (_unref(diaryStore)().updateDiaryDay(record))
                                                    }, null, 8, ["disabled", "value", "onUpdate:value", "onBlur"])
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_a_col, { span: 24 }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_16,
                                                    _hoisted_17,
                                                    (record.surveys.length)
                                                      ? (_openBlock(), _createBlock(_component_a_table, {
                                                          key: 0,
                                                          columns: surveyColumns.value,
                                                          "data-source": record.surveys,
                                                          pagination: false
                                                        }, {
                                                          bodyCell: _withCtx(({ column, record }) => [
                                                            (column.key === 'id')
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                  _createTextVNode(_toDisplayString(record.id), 1)
                                                                ], 64))
                                                              : _createCommentVNode("", true),
                                                            (column.key === 'type')
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                  _createTextVNode(_toDisplayString(record.survey_form.type_label), 1)
                                                                ], 64))
                                                              : _createCommentVNode("", true),
                                                            (column.key === 'survey_form')
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                                  _createTextVNode(_toDisplayString(record.survey_form.reference) + " - " + _toDisplayString(record.survey_form.name), 1)
                                                                ], 64))
                                                              : _createCommentVNode("", true),
                                                            (column.key === 'block')
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                                  _createTextVNode(_toDisplayString(record.block_name || '-'), 1)
                                                                ], 64))
                                                              : _createCommentVNode("", true),
                                                            (column.key === 'building')
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                                                  _createTextVNode(_toDisplayString(record.building_number || '-'), 1)
                                                                ], 64))
                                                              : _createCommentVNode("", true),
                                                            (column.key === 'completed_by_user')
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                                                  _createTextVNode(_toDisplayString(record.completed_by_user ? record.completed_by_user.full_name : '-'), 1)
                                                                ], 64))
                                                              : _createCommentVNode("", true),
                                                            (column.key === 'actions')
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                                                  (_unref(canViewSurveys))
                                                                    ? (_openBlock(), _createBlock(_component_a_button, {
                                                                        key: 0,
                                                                        size: "small",
                                                                        onClick: ($event: any) => (openInNewTab({ name: 'SurveyShow',  params: { surveyId: record.id } }))
                                                                      }, {
                                                                        default: _withCtx(() => [
                                                                          _createVNode(_unref(EyeOutlined))
                                                                        ]),
                                                                        _: 2
                                                                      }, 1032, ["onClick"]))
                                                                    : _createCommentVNode("", true)
                                                                ], 64))
                                                              : _createCommentVNode("", true)
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["columns", "data-source"]))
                                                      : (_openBlock(), _createElementBlock("span", _hoisted_18, "-"))
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_a_collapse_panel, { header: "Voortgang" }, {
                                          extra: _withCtx(() => [
                                            (record.text_progress && record.text_progress.length > 3)
                                              ? (_openBlock(), _createBlock(_unref(CheckOutlined), {
                                                  key: 0,
                                                  style: { color: 'green' }
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_row, { gutter: [16,16] }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_col, { span: 24 }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_19,
                                                    _createVNode(_component_a_textarea, {
                                                      style: {"min-width":"260px"},
                                                      autoSize: { minRows: 3, maxRows: 6 },
                                                      disabled: _unref(diaryClosed),
                                                      value: record.text_progress,
                                                      "onUpdate:value": ($event: any) => ((record.text_progress) = $event),
                                                      onBlur: ($event: any) => (_unref(diaryStore)().updateDiaryDay(record))
                                                    }, null, 8, ["disabled", "value", "onUpdate:value", "onBlur"])
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_a_col, { span: 24 }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_20,
                                                    _hoisted_21,
                                                    (record.inspections.length)
                                                      ? (_openBlock(), _createBlock(_component_a_table, {
                                                          key: 0,
                                                          columns: deliveryColumns.value,
                                                          "data-source": record.inspections,
                                                          pagination: false
                                                        }, {
                                                          bodyCell: _withCtx(({ column, record }) => [
                                                            (column.key === 'id')
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                  _createTextVNode(_toDisplayString(record.id), 1)
                                                                ], 64))
                                                              : _createCommentVNode("", true),
                                                            (column.key === 'building')
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                  _createTextVNode(_toDisplayString(record.building.number), 1)
                                                                ], 64))
                                                              : _createCommentVNode("", true),
                                                            (column.key === 'completed_by_user')
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                                  _createTextVNode(_toDisplayString(record.completed_by_user ? record.completed_by_user.full_name : '-'), 1)
                                                                ], 64))
                                                              : _createCommentVNode("", true),
                                                            (column.key === 'actions')
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                                  (_unref(canViewDeliveries))
                                                                    ? (_openBlock(), _createBlock(_component_a_button, {
                                                                        key: 0,
                                                                        size: "small",
                                                                        onClick: ($event: any) => (openInNewTab({ name: 'InspectionShow',  params: { deliveryId: record.id } }))
                                                                      }, {
                                                                        default: _withCtx(() => [
                                                                          _createVNode(_unref(EyeOutlined))
                                                                        ]),
                                                                        _: 2
                                                                      }, 1032, ["onClick"]))
                                                                    : _createCommentVNode("", true)
                                                                ], 64))
                                                              : _createCommentVNode("", true)
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["columns", "data-source"]))
                                                      : (_openBlock(), _createElementBlock("span", _hoisted_22, "-"))
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_a_col, { span: 24 }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_23,
                                                    _hoisted_24,
                                                    (record.deliveries.length)
                                                      ? (_openBlock(), _createBlock(_component_a_table, {
                                                          key: 0,
                                                          columns: deliveryColumns.value,
                                                          "data-source": record.deliveries,
                                                          pagination: false
                                                        }, {
                                                          bodyCell: _withCtx(({ column, record }) => [
                                                            (column.key === 'id')
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                  _createTextVNode(_toDisplayString(record.id), 1)
                                                                ], 64))
                                                              : _createCommentVNode("", true),
                                                            (column.key === 'building')
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                  _createTextVNode(_toDisplayString(record.building.number), 1)
                                                                ], 64))
                                                              : _createCommentVNode("", true),
                                                            (column.key === 'completed_by_user')
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                                  _createTextVNode(_toDisplayString(record.completed_by_user ? record.completed_by_user.full_name : '-'), 1)
                                                                ], 64))
                                                              : _createCommentVNode("", true),
                                                            (column.key === 'actions')
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                                  (_unref(canViewDeliveries))
                                                                    ? (_openBlock(), _createBlock(_component_a_button, {
                                                                        key: 0,
                                                                        size: "small",
                                                                        onClick: ($event: any) => (openInNewTab({ name: 'DeliveryShow',  params: { deliveryId: record.id } }))
                                                                      }, {
                                                                        default: _withCtx(() => [
                                                                          _createVNode(_unref(EyeOutlined))
                                                                        ]),
                                                                        _: 2
                                                                      }, 1032, ["onClick"]))
                                                                    : _createCommentVNode("", true)
                                                                ], 64))
                                                              : _createCommentVNode("", true)
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["columns", "data-source"]))
                                                      : (_openBlock(), _createElementBlock("span", _hoisted_25, "-"))
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_a_collapse_panel, { header: "Overlegstructuur" }, {
                                          extra: _withCtx(() => [
                                            (record.text_consultation_structure && record.text_consultation_structure.length > 3)
                                              ? (_openBlock(), _createBlock(_unref(CheckOutlined), {
                                                  key: 0,
                                                  style: { color: 'green' }
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_row, { gutter: [16,16] }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_col, { span: 24 }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_26,
                                                    _createVNode(_component_a_textarea, {
                                                      style: {"min-width":"260px"},
                                                      autoSize: { minRows: 3, maxRows: 6 },
                                                      disabled: _unref(diaryClosed),
                                                      value: record.text_consultation_structure,
                                                      "onUpdate:value": ($event: any) => ((record.text_consultation_structure) = $event),
                                                      onBlur: ($event: any) => (_unref(diaryStore)().updateDiaryDay(record))
                                                    }, null, 8, ["disabled", "value", "onUpdate:value", "onBlur"])
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_a_col, { span: 24 }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_27,
                                                    _hoisted_28,
                                                    (record.kickoffMeetingsWithSubcontractors.length)
                                                      ? (_openBlock(), _createBlock(_component_a_table, {
                                                          key: 0,
                                                          columns: kickoffMeetingsWithSubcontractorColumns.value,
                                                          "data-source": record.kickoffMeetingsWithSubcontractors,
                                                          pagination: false
                                                        }, {
                                                          bodyCell: _withCtx(({ column, record }) => [
                                                            (column.key === 'id')
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                  _createTextVNode(_toDisplayString(record.id), 1)
                                                                ], 64))
                                                              : _createCommentVNode("", true),
                                                            (column.key === 'form')
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                  _createTextVNode(_toDisplayString(record.name), 1)
                                                                ], 64))
                                                              : _createCommentVNode("", true),
                                                            (column.key === 'company')
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                                  _createTextVNode(_toDisplayString(record.company || '-'), 1)
                                                                ], 64))
                                                              : _createCommentVNode("", true),
                                                            (column.key === 'created_by_user')
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                                  _createTextVNode(_toDisplayString(record.created_by_user ? record.created_by_user.full_name : '-'), 1)
                                                                ], 64))
                                                              : _createCommentVNode("", true),
                                                            (column.key === 'actions')
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                                                  (_unref(canViewKam))
                                                                    ? (_openBlock(), _createBlock(_component_a_button, {
                                                                        key: 0,
                                                                        size: "small",
                                                                        onClick: ($event: any) => (openInNewTab({ name: 'KAMFormEdit',  params: { formReference: record.reference, projectReference: record.project.reference, kamFormId: record.id } }))
                                                                      }, {
                                                                        default: _withCtx(() => [
                                                                          _createVNode(_unref(EyeOutlined))
                                                                        ]),
                                                                        _: 2
                                                                      }, 1032, ["onClick"]))
                                                                    : _createCommentVNode("", true)
                                                                ], 64))
                                                              : _createCommentVNode("", true)
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["columns", "data-source"]))
                                                      : (_openBlock(), _createElementBlock("span", _hoisted_29, "-"))
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_a_collapse_panel, { header: "Overige zaken" }, {
                                          extra: _withCtx(() => [
                                            (record.text_other && record.text_other.length > 3)
                                              ? (_openBlock(), _createBlock(_unref(CheckOutlined), {
                                                  key: 0,
                                                  style: { color: 'green' }
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          default: _withCtx(() => [
                                            _hoisted_30,
                                            _createVNode(_component_a_textarea, {
                                              style: {"min-width":"260px"},
                                              autoSize: { minRows: 3, maxRows: 6 },
                                              disabled: _unref(diaryClosed),
                                              value: record.text_other,
                                              "onUpdate:value": ($event: any) => ((record.text_other) = $event),
                                              onBlur: ($event: any) => (_unref(diaryStore)().updateDiaryDay(record))
                                            }, null, 8, ["disabled", "value", "onUpdate:value", "onBlur"])
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_a_collapse_panel, { header: "Bestanden" }, {
                                          extra: _withCtx(() => [
                                            _createVNode(_unref(FileOutlined)),
                                            _createTextVNode(" " + _toDisplayString(record.files.length), 1)
                                          ]),
                                          default: _withCtx(() => [
                                            _hoisted_31,
                                            (!_unref(diaryClosed))
                                              ? (_openBlock(), _createBlock(Uploader, {
                                                  key: 0,
                                                  "allowed-extensions": ['jpeg', 'png', 'pdf'],
                                                  "current-count": record.files.length,
                                                  "upload-button": "",
                                                  onNewFileUploaded: ($event: any) => (addFile(record, $event))
                                                }, null, 8, ["current-count", "onNewFileUploaded"]))
                                              : _createCommentVNode("", true),
                                            (record.files.length)
                                              ? (_openBlock(), _createBlock(Filelist, {
                                                  key: 1,
                                                  media: record.files,
                                                  "can-delete": !_unref(diaryClosed),
                                                  onDeleteFile: ($event: any) => (deleteFile(record, $event))
                                                }, null, 8, ["media", "can-delete", "onDeleteFile"]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["columns", "data-source"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_a_card, {
                  key: 1,
                  title: "Aan het laden..",
                  bordered: false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_skeleton, { active: "" })
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        }),
        (_unref(diaryStore)().diary)
          ? (_openBlock(), _createBlock(_component_a_col, {
              key: 0,
              span: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_card, {
                  title: "Aanwezigheid",
                  bordered: false
                }, {
                  extra: _withCtx(() => [
                    (!_unref(diaryClosed))
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 0,
                          type: "primary",
                          onClick: toggleNewRegistrationModal
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(PlusOutlined))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (!_unref(diaryClosed))
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 1,
                          style: { marginLeft: '8px' },
                          onClick: toggleCopyRegistrationsModal
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(CopyOutlined))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_row, { gutter: [16,16] }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, {
                          xs: {span: 24},
                          sm: {span: 24},
                          md: {span: 24},
                          lg: {span: 24}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_table, {
                              columns: registrationColumns.value,
                              "data-source": _unref(diaryStore)().diary.registrations,
                              pagination: false,
                              scroll: { x: true }
                            }, {
                              bodyCell: _withCtx(({ column, record }) => [
                                (column.key === 'company')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(record.company.name), 1)
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (column.key === 'monday')
                                  ? (_openBlock(), _createBlock(_component_a_input_number, {
                                      key: 1,
                                      min: 0,
                                      disabled: _unref(diaryClosed),
                                      value: record.monday,
                                      "onUpdate:value": ($event: any) => ((record.monday) = $event),
                                      onBlur: ($event: any) => (_unref(diaryStore)().updateDiaryRegistration(record))
                                    }, null, 8, ["disabled", "value", "onUpdate:value", "onBlur"]))
                                  : _createCommentVNode("", true),
                                (column.key === 'tuesday')
                                  ? (_openBlock(), _createBlock(_component_a_input_number, {
                                      key: 2,
                                      min: 0,
                                      disabled: _unref(diaryClosed),
                                      value: record.tuesday,
                                      "onUpdate:value": ($event: any) => ((record.tuesday) = $event),
                                      onBlur: ($event: any) => (_unref(diaryStore)().updateDiaryRegistration(record))
                                    }, null, 8, ["disabled", "value", "onUpdate:value", "onBlur"]))
                                  : _createCommentVNode("", true),
                                (column.key === 'wednesday')
                                  ? (_openBlock(), _createBlock(_component_a_input_number, {
                                      key: 3,
                                      min: 0,
                                      disabled: _unref(diaryClosed),
                                      value: record.wednesday,
                                      "onUpdate:value": ($event: any) => ((record.wednesday) = $event),
                                      onBlur: ($event: any) => (_unref(diaryStore)().updateDiaryRegistration(record))
                                    }, null, 8, ["disabled", "value", "onUpdate:value", "onBlur"]))
                                  : _createCommentVNode("", true),
                                (column.key === 'thursday')
                                  ? (_openBlock(), _createBlock(_component_a_input_number, {
                                      key: 4,
                                      min: 0,
                                      disabled: _unref(diaryClosed),
                                      value: record.thursday,
                                      "onUpdate:value": ($event: any) => ((record.thursday) = $event),
                                      onBlur: ($event: any) => (_unref(diaryStore)().updateDiaryRegistration(record))
                                    }, null, 8, ["disabled", "value", "onUpdate:value", "onBlur"]))
                                  : _createCommentVNode("", true),
                                (column.key === 'friday')
                                  ? (_openBlock(), _createBlock(_component_a_input_number, {
                                      key: 5,
                                      min: 0,
                                      disabled: _unref(diaryClosed),
                                      value: record.friday,
                                      "onUpdate:value": ($event: any) => ((record.friday) = $event),
                                      onBlur: ($event: any) => (_unref(diaryStore)().updateDiaryRegistration(record))
                                    }, null, 8, ["disabled", "value", "onUpdate:value", "onBlur"]))
                                  : _createCommentVNode("", true),
                                (column.key === 'saturday')
                                  ? (_openBlock(), _createBlock(_component_a_input_number, {
                                      key: 6,
                                      min: 0,
                                      disabled: _unref(diaryClosed),
                                      value: record.saturday,
                                      "onUpdate:value": ($event: any) => ((record.saturday) = $event),
                                      onBlur: ($event: any) => (_unref(diaryStore)().updateDiaryRegistration(record))
                                    }, null, 8, ["disabled", "value", "onUpdate:value", "onBlur"]))
                                  : _createCommentVNode("", true),
                                (column.key === 'sunday')
                                  ? (_openBlock(), _createBlock(_component_a_input_number, {
                                      key: 7,
                                      min: 0,
                                      disabled: _unref(diaryClosed),
                                      value: record.sunday,
                                      "onUpdate:value": ($event: any) => ((record.sunday) = $event),
                                      onBlur: ($event: any) => (_unref(diaryStore)().updateDiaryRegistration(record))
                                    }, null, 8, ["disabled", "value", "onUpdate:value", "onBlur"]))
                                  : _createCommentVNode("", true),
                                (column.key === 'actions')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                                      (record.amount_signaling)
                                        ? (_openBlock(), _createBlock(_component_a_badge, {
                                            key: 0,
                                            color: "#f38529",
                                            dot: ""
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_button, {
                                                style: { fontWeight: 600 },
                                                onClick: ($event: any) => (toggleSignalingModal(record))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("€")
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"])
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : (_openBlock(), _createBlock(_component_a_button, {
                                            key: 1,
                                            style: { fontWeight: 600 },
                                            onClick: ($event: any) => (toggleSignalingModal(record))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("€")
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])),
                                      (!_unref(diaryClosed))
                                        ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                                            key: 2,
                                            placement: "left",
                                            "ok-text": "Ja",
                                            "cancel-text": "Nee",
                                            onConfirm: ($event: any) => (deleteDiaryRegistration(record.id))
                                          }, {
                                            title: _withCtx(() => [
                                              _hoisted_32
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_button, {
                                                style: {"margin-left":"8px"},
                                                disabled: _unref(diaryStore)().loading.deleting == record.id
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(DeleteOutlined))
                                                ]),
                                                _: 2
                                              }, 1032, ["disabled"])
                                            ]),
                                            _: 2
                                          }, 1032, ["onConfirm"]))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]),
                              summary: _withCtx(() => [
                                _createVNode(_component_a_table_summary, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_table_summary_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_table_summary_cell, { style: { fontWeight: 800 } }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Totaal")
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_a_table_summary_cell, { style: { fontWeight: 800 } }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(registrationsCounter).monday), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_a_table_summary_cell, { style: { fontWeight: 800 } }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(registrationsCounter).tuesday), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_a_table_summary_cell, { style: { fontWeight: 800 } }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(registrationsCounter).wednesday), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_a_table_summary_cell, { style: { fontWeight: 800 } }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(registrationsCounter).thursday), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_a_table_summary_cell, { style: { fontWeight: 800 } }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(registrationsCounter).friday), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_a_table_summary_cell, { style: { fontWeight: 800 } }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(registrationsCounter).saturday), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_a_table_summary_cell, { style: { fontWeight: 800 } }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(registrationsCounter).sunday), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_a_table_summary_cell)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["columns", "data-source"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            (!_unref(diaryClosed))
                              ? (_openBlock(), _createBlock(_component_a_button, {
                                  key: 0,
                                  type: "primary",
                                  onClick: toggleNewRegistrationModal
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(PlusOutlined)),
                                    _createTextVNode(" Bedrijf toevoegen")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            (!_unref(diaryClosed))
                              ? (_openBlock(), _createBlock(_component_a_button, {
                                  key: 0,
                                  onClick: toggleCopyRegistrationsModal
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(CopyOutlined)),
                                    _createTextVNode(" Kopiëren van eerdere week")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      title: "Bedrijf toevoegen aan uitvoerdersdagboek.",
      "ok-text": "Toevoegen",
      visible: showNewRegistrationModal.value,
      "ok-button-props": { loading: _unref(diaryStore)().loading.saving, disabled: _unref(diaryStore)().loading.saving },
      onOk: addCompany,
      onCancel: toggleNewRegistrationModal
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, { class: "no-mb" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _hoisted_33,
                _createVNode(_component_a_select, {
                  "field-names": { label: 'name', value: 'id' },
                  filterOption: filterByName,
                  options: companies.value,
                  value: newRegistration.value.company_id,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((newRegistration.value.company_id) = $event)),
                  "show-search": ""
                }, null, 8, ["options", "value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible", "ok-button-props"]),
    _createVNode(_component_a_modal, {
      title: "Aanwezigheid kopiëren van eerdere week.",
      "ok-text": "Kopieer",
      visible: showCopyRegistrationsModal.value,
      "ok-button-props": { loading: _unref(diaryStore)().loading.saving, disabled: _unref(diaryStore)().loading.saving },
      onOk: copyDiaryRegistrations,
      onCancel: toggleCopyRegistrationsModal
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _hoisted_34,
                _hoisted_35
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_row, { class: "no-mb" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _hoisted_36,
                _createVNode(_component_a_select, {
                  "field-names": { label: 'name', value: 'id' },
                  filterOption: filterByName,
                  options: previousWeeks.value,
                  value: diaryIdToCopyFrom.value,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((diaryIdToCopyFrom).value = $event)),
                  "show-search": ""
                }, null, 8, ["options", "value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible", "ok-button-props"]),
    (showSignalingModal.value && diaryRegistration.value)
      ? (_openBlock(), _createBlock(_component_a_modal, {
          key: 0,
          title: "Signalering meer- minderwerk.",
          "ok-text": "Opslaan",
          visible: showSignalingModal.value,
          onCancel: _cache[6] || (_cache[6] = ($event: any) => (toggleSignalingModal()))
        }, {
          footer: _withCtx(() => [
            (!_unref(diaryClosed))
              ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                  key: 0,
                  placement: "top",
                  "ok-text": "Ja",
                  "cancel-text": "Nee",
                  onConfirm: clearSignaling
                }, {
                  title: _withCtx(() => [
                    _hoisted_42
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      loading: _unref(diaryStore)().loading.clearing,
                      disabled: _unref(diaryStore)().loading.clearing
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Signalering wissen")
                      ]),
                      _: 1
                    }, 8, ["loading", "disabled"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_a_button, {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (toggleSignalingModal()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Annuleren")
              ]),
              _: 1
            }),
            (!_unref(diaryClosed))
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 1,
                  type: "primary",
                  loading: _unref(diaryStore)().loading.saving,
                  disabled: _unref(diaryStore)().loading.saving || !diaryRegistration.value.text_signaling || diaryRegistration.value.amount_signaling === null,
                  onClick: storeSignaling
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Opslaan")
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"]))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _hoisted_37,
                    _createVNode(_component_a_textarea, {
                      style: {"min-width":"100%"},
                      autoSize: { minRows: 3, maxRows: 6 },
                      value: diaryRegistration.value.text_signaling,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((diaryRegistration.value.text_signaling) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _hoisted_38,
                    _hoisted_39,
                    _createVNode(_component_a_input_number, {
                      style: { width: '100%' },
                      value: diaryRegistration.value.amount_signaling,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((diaryRegistration.value.amount_signaling) = $event))
                    }, {
                      addonBefore: _withCtx(() => [
                        _createTextVNode("+/-")
                      ]),
                      addonAfter: _withCtx(() => [
                        _createTextVNode("EUR")
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, { class: "no-mb" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _hoisted_40,
                    _hoisted_41,
                    _createTextVNode(" € " + _toDisplayString(diaryRegistration.value.total_amount_signaling), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["visible"]))
      : _createCommentVNode("", true)
  ]))
}
}

})